"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toNetworkType = void 0;
const types_1 = require("@shapeshiftoss/types");
const toNetworkType = (network) => {
    switch (network) {
        case 'mainnet':
            return types_1.NetworkTypes.MAINNET;
        case 'testnet':
            return types_1.NetworkTypes.TESTNET;
        default:
            throw new Error('unsupported network');
    }
};
exports.toNetworkType = toNetworkType;
